var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticClass:"iframe-box",attrs:{"id":"gameIframe","title":"Game Server Iframe","src":_vm.iframeSrc,"allow":"fullscreen"}})}
var staticRenderFns = []

export { render, staticRenderFns }